import { type UseMutationResult } from 'react-query'

import { type UseMutationResultFlag } from 'components/status-checks/hooks/types'

export const USE_COMBINE_MUTATION_RESULT_FLAGS = [
  'isError',
  'isIdle',
  'isLoading',
  'isSuccess'
] as const

const unionFlagTypes = new Set(['isIdle', 'isSuccess'])

/**
 * Combines the flag states of multiple mutation results using specific logic:
 * - For `isSuccess` & `isIdle`, all mutation results must be successful (AND logic).
 * - For all other flags, use OR logic.
 */
export function combineMutationResponseStatusFlags(
  keys: ReadonlyArray<UseMutationResultFlag>,
  results: Pick<
    UseMutationResult,
    Exclude<UseMutationResultFlag, 'isCanceled'>
  >[]
) {
  return keys.reduce<Record<UseMutationResultFlag, boolean>>((record, key) => {
    record[key] = unionFlagTypes.has(key)
      ? results.every((result) => result[key])
      : results.some((result) => result[key])
    return record
  }, Object.create(null))
}
